import { createSocialInsightSelector } from 'selectors/feedSelectors'
import { createSelector } from 'reselect'
import { createInsightByIdSelector } from 'selectors/insightsSelectors'

export const createInsightBySocialInsightSelector = () => createSelector(
  (state) => state,
  createSocialInsightSelector(),
  (state, socialInsight) => {
    if (!socialInsight || !socialInsight.placement || !socialInsight.insightId) {
      return null
    }

    const insightSelector = createInsightByIdSelector(socialInsight.placement, socialInsight.insightId)
    return insightSelector(state)
  }
)
